import React from 'react';
import { Grid } from 'src/components/Grid/Grid';

import { Image } from 'src/components/Image/Image';
import quotesMark from 'src/images/icons/quotes_mark.svg';
import naImage from 'src/images/na.png';
import { AppType, Asset } from 'src/services/cms/typesUtil';
import { TextV2 } from '../TextV2/TextV2';
import styles from './SingleTestimonialModule.scss';

type SingleTestimonialModuleProps = AppType.Component<{
  quote: string;
  personName: string;
  video: Asset;
  businessName: string;
  location: string;
}>;

export const SingleTestimonialModule: React.FC<SingleTestimonialModuleProps> = ({
  video,
  quote,
  personName,
  businessName,
  location,
  ...props
}) => {
    return (
       <Grid container justifyContent="center" className={styles.testimonialContainer} {...props._attributes}>
        {video && (
        <Grid item md={3} xs={12}>
           <Image src={naImage} aria-hidden className={styles.testimonialContainerVideo} />
        </Grid>
        )}
        {quote && personName && (
          <Grid item lg={7} md={9} xs={12} className={styles.testimonialContainerRight}>
            <div className={styles.testimonialContainerRightSideContents}>
            <Image src={quotesMark} aria-hidden className={styles.testimonialContainerQuotesImage} />
              <div className={styles.testimonialContainerText}>
                <TextV2 variant="h4" tagName="h4" value={quote} data-test="quote-text" />
                <div className={styles.smallText}>
                  <TextV2 variant="body-small-bold" value={personName} className={styles.nameText}>
                    <span className={styles.separatorToHide} />
                  </TextV2>
                  <TextV2 variant="body-small" value={businessName}>
                    <span className={styles.pipeSeparator} />
                  </TextV2>
                  <TextV2 variant="body-small" value={location} />
                </div>
              </div>
            </div>
          </Grid>
        )}
       </Grid>
  );
};
